import axios from "axios";
import React from "react";
import { jsonHeader } from '../util/GeneralUtil'
const apiUrl = process.env.REACT_APP_API_URL;


async function getAll(payload) {
    const result = await axios.post(apiUrl + "/admin/getmasters",payload,{
        headers: jsonHeader}
    );
    return result.data || [];
}

async function getTableData(payload) {
    const resultdata = await axios.post(apiUrl + "/log/trade",payload,{
        headers: jsonHeader}
    );

    return resultdata.data || [];
}

export const RejectionLogServices = {
    getAll,
    getTableData
}